<template>
    <div class="FormPayOrderRegistration">
        <v-easy-dialog v-model="simpleDialog">
            <div v-if="modalEnd" class="flex flex-col v-card textSend">
                <div>
                    <p class = "titleModal">
                        <strong>Confirmamos la recepción de la solicitud. A continuación los pasos del proceso de gestión:</strong>
                    </p>
                </div>
                <hr/>
                <div class = "infoModal">
                    <p>
                        1. Tú certificado será emitido a tu correo electrónico en los próximos 2 días hábiles
                    </p>
                    <p>   
                        2. Para la expedición de un nuevo certificado debes realizar nuevamente el proceso. 
                    </p>
                </div>
                <div class="flex justify-end space-x-2">
                    <button id="btnClose" v-on:click="closeModal" style="float: right;">Cerrar</button>
                </div>
            </div>
            <div v-if="modalLoading" class="flex flex-col v-card textSend">
                <div>
                    <p class = "titleModal">
                        Danos un momento mientras procesamos la información
                    </p>
                </div>
            </div>
        </v-easy-dialog>
        <b-modal v-model="modalShow" hide-footer>
      <div class="d-block text-center">
        <h3>{{DangerFileModal}}</h3>
      </div>
    <b-button class="mt-3" block v-on:click="closeModel" style="background-color: #fff;">Cerrar</b-button>
    </b-modal>
        <div v-if="FormPayOrderRegistration">
            <div class="container justify-content-center container-form">
                <div class="row">
                    <div class="col-md-7 totalform motBusUser">
                        <div v-if="infoData" class="alert alert-danger">
                            <p>
                                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7466876 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoDataExistCase" class="alert alert-danger">
                            <p>
                                Estimado usuario. Ya existe un caso con soporte de pago anexado. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7466876 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoCorrect" class="alert alert-success">
                            <p>
                                Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso y será atendido lo más pronto posible.
                            </p>
                        </div>
                        <h1 class="titleForm"><strong>¿Ya realizaste el pago? ¡No te preocupes!</strong></h1>
                        <p class="descriptionForm">
                            Diligencia el formulario que encontrarás a continuación y adjunta el recibo de pago. 
                            Utilizaremos el resto de tu información para actualizar tus datos y asegurarnos de siempre estar en contacto.
                        </p>
                        <ValidationObserver ref="obsFormPayOrderRegistration">
                            <FormPayOrderRegistration :FieldsForm="FormPayOrderRegistration" :ModelForm="formInsModel" :method="executeProcess" />                                     
                        </ValidationObserver>
                        <div class="botoPnrocess">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="onComplete"
                                            class="loginbtn">
                                            Validar
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataInscription from '@/views/InfoZone/FormPayOrderCertificate.vue'
    import FormPayOrderRegistration from '@/components/Forms.vue'
    import IberoHelpers from '@/store/helpers.js'
    import VEasyDialog from 'v-easy-dialog'

    export default{
        name: "FormOrderCertificate",
        components: {
            FormDataInscription,
            FormPayOrderRegistration,
            VEasyDialog,
        },
        methods:{
            closeModel: function () {
                this.modalShow = false
            },
            dataObjCheck: function(InfDaT){
                if(InfDaT === true){
                    return this.$ml.get('Accepted');   
                }
                return this.$ml.get('NotAccepted');    
                },
            closeModal: function () {
                this.simpleDialog = false;
                window.open("#");
                this.clearFields();
            },
            loadFindData: function(restJson){
                debugger;
                document.getElementById("IdNombres").readOnly = true;
                document.getElementById("IdApellidos").readOnly = true;
                document.getElementById("IdCertificateType").readOnly = true;
                document.getElementById("IdDocument").readOnly = true;
                document.getElementById("IdDocumentType").readOnly = true;
                document.getElementById("IdProgram").readOnly = true;
                document.getElementById("IdPeriod").readOnly = true;
                document.getElementById("IdBanner").readOnly = true;
                document.getElementById("IdEmail").readOnly = true;
                document.getElementById("IdSendType").readOnly = true;                

                this.formInsModel.IdNombres = restJson.nombres
                this.formInsModel.IdApellidos = restJson.apellidos
                this.formInsModel.IdCertificateType = restJson.typeCertficate
                this.formInsModel.IdDocument = restJson.documento
                this.formInsModel.IdDocumentType = restJson.tipoDocumento
                this.formInsModel.IdBanner = restJson.idBanner
                this.formInsModel.IdProgram = restJson.program
                this.formInsModel.IdPeriod = restJson.periodCertificate
                this.formInsModel.IdEmail = restJson.person_University
                this.formInsModel.IdSendType = restJson.typeSend
            },
            clearFields: function(){
                document.getElementById("IdNombres").readOnly = true;
                document.getElementById("IdApellidos").readOnly = true;
                document.getElementById("IdCertificateType").readOnly = true;
                document.getElementById("IdDocument").readOnly = true;
                document.getElementById("IdDocumentType").readOnly = true;
                document.getElementById("IdProgram").readOnly = true;
                document.getElementById("IdPeriod").readOnly = true;
                document.getElementById("IdBanner").readOnly = true;
                document.getElementById("IdCase").readOnly = false;
                document.getElementById("IdEmail").readOnly = true;
                document.getElementById("IdSendType").readOnly = true;                
                document.getElementById("IdFile").readOnly = false;
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdCertificateType = ''
                this.formInsModel.IdDocument = ''
                this.formInsModel.IdDocumentType = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdProgram = ''
                this.formInsModel.IdPeriod = ''
                this.formInsModel.IdCase = ''
                this.formInsModel.IdEmail = ''
                this.formInsModel.IdFile = ''
                this.formInsModel.IdSendType = ''
                this.$refs.IdFile.value=null;
                this.simpleDialog = false;
            },
            dataformat: function(InfDaT){
                return IberoHelpers.dataObjDate(InfDaT);
            },
            dataObjFindJs: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjFind(infoDaT,FinDaT);
            },
            dataObjAllFind: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
            },
            executeProcess: function (event){
                switch (event.target.id){
                    case "IdCase":
                        if(event.type === 'blur' && this.formInsModel.IdCase !== ''){       
                        debugger
                        var LoadData = IberoHelpers.findCase(this.$store, this.formInsModel);
                        LoadData.then(Response => {
                            debugger
                            console.log(Response.data.documento)
                            if (Response.data.documento == null || Response.data.documento == "NO EXISTE") {            
                                this.infoData = true;
                                this.infoDataExistCase = false;
                                this.clearFields()
                            }
                            if (Response.data.documento == "EXISTE") {            
                                this.infoData = false;
                                this.infoDataExistCase = true;
                                this.clearFields()
                            }
                            else
                            {
                                debugger;
                                this.loadFindData(Response.data)
                                this.infoData = false;
                                this.infoDataExistCase = false;
                            }
                        })
                        }
                    break;
                    case 'IdFile':
                     debugger
                     if(this.formInsModel.IdCase != "")
                     {
                        this.formUserFileModel = []  
                        var dataFile = event.target.files[0].type
                        debugger
                        if (dataFile.includes('pdf') || dataFile.includes('jpg') || dataFile.includes('png')) {
                            var dataFileSize = event.target.files[0].size
                            if (dataFileSize < 2000000)
                            {
                            var fileData =  event.target.files[0]
                            event.target.nextElementSibling.innerText = fileData.name
                            this.formInsModel.IdFile = fileData.name
                            this.formUserFileModel.push({ filedata: fileData })
                            }
                            else
                            {
                                this.DangerFileModal = "No se permiten archivos mayores a 2 MB"
                                this.modalShow = true
                                this.formInsModel.IdFile = ''
                            }
                        }
                        else
                        {
                            this.DangerFileModal = "Solo se permiten archivos con extensión pdf, jpg o png"
                            this.modalShow = true
                            this.formInsModel.IdFile = ''
                        }
                    }
                    break;  
                }
            },
            UpdateUser: function() {
                debugger
                return new Promise((resolve, reject) => {
                    this.$refs.FormPayOrderRegistration.validate().then(results => {     
                        debugger   
                        if (!results) {
                            IberoHelpers.scrollToTop(0,500);
                            resolve(false)
                        }else{
                            this.FormPayOrderRegistration = false;
                            resolve(true)
                        }
                    });
                });
            },
            goBackForm: function(){
                debugger
                this.FormPayOrderRegistration = true;
                this.formInsModel.IdDocumentType = ''
                this.formInsModel.IdDocument = ''
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdCertificateType = ''
                this.formInsModel.IdCase = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdProgram = ''
                this.formInsModel.IdPeriod = ''
                this.formInsModel.IdEmail = ''
                this.formInsModel.IdFile = ''
                this.formInsModel.IdSendType = ''
            },
            onComplete(){
                try{
                    debugger
                    if(this.formUserFileModel.length > 0)
                    {
                        if(this.formInsModel.IdCase != "" && this.formInsModel.IdDocument != "")
                        {
                            this.simpleDialog = true;
                            this.modalLoading = true;
                            var dataFile = IberoHelpers.sendUpdloadFile(this.$store, this.formUserFileModel, 'CERTIFICATE', 0)
                            dataFile.then(Response => { 
                                debugger
                                if (!(Response === false)){
                                    for (var i=0; i < Response.length; i++){
                                        debugger
                                        let valueRef = Response[i].wsDocument.data.id_File
                                        let URIFile = Response[i].wsDocument.data.filePath
                                        let refeFile = []  
                                        refeFile.push({valueRef, URIFile: URIFile})
                                        var FileZoho = { 
                                            idCase: this.formInsModel.IdCase,
                                            typeIdentification : this.formInsModel.IdDocumentType,
                                            Identification: this.formInsModel.IdDocument,
                                            Name: this.formInsModel.IdNombres,
                                            LastName: this.formInsModel.IdApellidos,
                                            IdBanner: this.formInsModel.IdBanner,
                                            Email: this.formInsModel.IdEmail,
                                            Program: this.formInsModel.IdProgram,
                                            TypeCertificate: this.formInsModel.IdCertificateType,
                                            Period: this.formInsModel.IdPeriod,
                                            FileDetail: refeFile,
                                            TypeSend: this.formInsModel.IdSendType,
                                        }
                                        var resulEnd = IberoHelpers.sendFilesCaseCertificate(this.$store, FileZoho);
                                        debugger; 
                                        resulEnd.then(Response => {
                                            debugger
                                            if (!(Response === false)) {
                                                if (Response.data.status === '200') {
                                                    debugger                                
                                                    this.modalLoading = false;
                                                    this.modalEnd = true;
                                                    IberoHelpers.scrollToTop(0,500);
                                                    resolve(true);
                                                } else {
                                                    this.simpleDialog = false;
                                                    this.modalLoading = false;
                                                    this.infoData = true;
                                                    resolve(false);
                                                }
                                            } else {
                                                this.simpleDialog = false;
                                                this.modalLoading = false;
                                                this.infoData = true;
                                                resolve(false);
                                            }                               
                                        })
                                    }
                                }
                            })
                        }
                        else
                        {
                            debugger
                            this.simpleDialog = false;
                            this.modalLoading = false;
                            this.infoData = true;
                        }
                    }
                    else
                    {
                        this.simpleDialog = false;
                        this.modalLoading = false;
                         this.infoData = true;
                    }
                }
                catch(error) {    
                    this.simpleDialog = false;
                    this.modalLoading = false;
                    this.infoData = true;
                    resolve(false);
                };                    
            },
        },
        data(){
            return {
                DangerFileModal: '',
                modalShow: false,
                FormPayOrderRegistration: true,
                infoData: false,
                infoDataExistCase: false,
                infoCorrect: false,
                dangerData: false,
                simpleDialog: false,
                sumaryData: [],
                NamePerson: [],
                LastnamePerson: [],
                IdType: [],
                Identification: [],
                formUserFileModel: [],
                alertnofile: false,
                modalEnd: false,
                modalLoading: false,
                alertnofileSend: false,
                alertfile: false,
                formInsModel:{
                    Campaign: this.$route.params.referencia,
                    IdCase: '',
                    IdDocumentType: '',
                    IdDocument: '',
                    IdNombres: '',
                    IdApellidos: '',
                    IdBanner: '',
                    IdPeriod: '',
                    IdProgram: '',
                    IdCertificateType: '',
                    IdEmail: '',
                    IdFile: '',
                    IdSendType: '',
                },
                FormPayOrderRegistration:[
                    {            
                        id: 'IdCase',
                        model: 'IdCase',
                        //name: 'Numero del caso',
                        type: 'input',  
                        placeholder: 'Numero del caso', 
                        values: '',
                        validate: {              
                        required: true, 
                        min: 19,              
                        max: 20            
                        },
                        class: 'col-md-12'               
                    },  
                    {            
                        id: 'IdDocumentType',
                        model: 'IdDocumentType',
                        //name: 'Tipo de Documento',
                        type: 'input',  
                        placeholder: "Tipo de Documento",
                        values: this.$store.state.DocTypesList,
                        readonly:"isReadOnly",
                        validate: {              
                            required: true,              
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdDocument',
                        model: 'IdDocument',
                        //name: 'Documento de Identidad',
                        type: 'input',  
                        placeholder: 'Documento de Identidad',
                        readonly:"isReadOnly",
                        disabled: false,
                        values: '',
                        validate: {              
                            required: true          
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdNombres',
                        model: 'IdNombres',
                        //name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Nombres',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                            required: true 
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdApellidos',
                        model: 'IdApellidos',
                        //name: 'Apellidos',
                        type: 'input',  
                        placeholder: 'Apellidos',
                        values: '',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6',               
                    },
                    {            
                        id: 'IdBanner',
                        model: 'IdBanner',
                        //name: 'Id Banner',
                        type: 'input',  
                        placeholder: "Id Banner",
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                            required: true,              
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdEmail',
                        model: 'IdEmail',
                        //name: 'Periodo',
                        type: 'input',  
                        placeholder: "Correo Institucional",
                        values: '',
                        readonly: "isReadOnly",
                        validate: {              
                            required: true,              
                        },
                        class: 'col-md-6',
                    },
                    {
                        id: 'IdProgram',
                        model: 'IdProgram',
                        //name: 'Programa a Certificar',
                        type: 'input',  
                        placeholder: 'Programa a Certificar',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: '',
                    },
                    {
                        id: 'IdCertificateType',
                        model: 'IdCertificateType',
                        //name: 'Tipo de Certificación o Duplicado',
                        type: 'input',  
                        readonly:"isReadOnly",
                        placeholder: 'Tipo de Certificación o Duplicado',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: '',
                    },
                    {            
                        id: 'IdPeriod',
                        model: 'IdPeriod',
                        //name: 'Periodo',
                        type: 'input',  
                        placeholder: "Periodo",
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                            required: true,              
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdSendType',
                        model: 'IdSendType',
                        //name: 'Periodo',
                        type: 'input',  
                        placeholder: "Type Send",
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                            required: true,              
                        },
                        class: 'col-md-6',
                    },
                    {
                        id: 'IdFile',
                        placeholder: 'Examinar',
                        name: 'Adjuntar archivo',
                        type: 'file',
                        values: '',
                        validate: {
                            required: true,
                        },
                        class: 'col-md-12',
                        ref: 'IdFile'
                    }, 
                ]
            }
        }
    }
</script>

<style scope>
.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 10px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.titleRef {
    font-weight: bold;
    padding-bottom: 0px;
    margin-top: 20px;
}

.titleForm {
    color: #222;
}

.descriptionForm {
    padding: 10px 10px 0px 10px;
    font-size: 12px;
    margin: 0px;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
    margin-bottom: 5px;
}

.container-form{
    padding: 30px 0;
    box-sizing: border-box;
}

.motBusUser{
    padding: 5px;
    border-radius: 5px;
    margin: 10px auto;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    background:  #fff !important;
}

body {
    background:  #fff !important;   
}
header {
    background:  #ffffff !important;   
}

.table > tbody > tr > td {
    vertical-align: middle !important;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
    color: #222;
}

.active
{
    color: #222;
}

#IdObservation {
    height: 90px;
}

.botoPnrocess {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 10px;
}
button:hover {
    background-color: #222;
    color: #fff;
}
.loginbtn {
    width: 90%;
    background-color: #fff;
    color: #222;
    border: #222 solid 2px !important;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
}

.validateBtn{
    width: 90%;
    border-color: #222;
    background-color: #fff;
    color: #222;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
    margin: 0px 10px 10px 10px;
}

/* Modal validación de datos */
.InscFiles{
    margin: 20px;
}

/* Grid validación data */
.wrapper {
    display: grid;
    margin: 10px 10px 10px 10px;
    padding: 1px 1px 1px 1px;
    grid-template-columns: repeat(2, 1fr);
    border: 1px solid black;
    grid-gap: 1px;
    background-color: black;
}

.wrapper > div {
    background-color: white;
    padding: 10px;
    text-align: center;
}

/* Estilos dedicados al Modal */
#btnClose{
    margin: 10px 10px 10px 10px;
    border-radius: 5px;
    border-color: #222;
    background-color: #fff;
    color: #222;
}
#btnClose:hover{
    background-color: #222;
    color: #fff;
}
hr{
    margin: 5px 10px;
}
.titleModal{
    font-size: 20px !important;
}
.v-easy-dialog--transition-ease-in {
    transform: scale(1);
    transition: opacity cubic-bezier(0.4, 0, 1, 1) 0.15s,
        transform cubic-bezier(0.4, 0, 1, 1) 0.15s;
}
.v-easy-dialog--transition-ease-out {
    transform: scale(1);
    transition: opacity cubic-bezier(0, 0, 0.2, 1) 0.15s,
        transform cubic-bezier(0, 0, 0.2, 1) 0.15s;
}
.v-easy-dialog--content-transition-opened {
    opacity: 1;
    transform: scale(1);
}
.v-easy-dialog--content-transition-closed {
    opacity: 0;
    transform: scale(0);
}
.v-easy-dialog--opacity-0 {
    opacity: 0;
}
.v-easy-dialog--opacity-100 {
    opacity: 100;
}
.v-easy-dialog--backdrop {
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    touch-action: none;
}
.v-easy-dialog--backdrop-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: default;
}
.v-easy-dialog--backdrop-btn:hover{
    background-color: rgba(0, 0, 0, 0) !important;
}
.v-easy-dialog--fullscreen {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
.v-easy-dialog--content-grow *:first-child {
    flex-grow: 1;
}
.v-easy-dialog--content-container {
    display: flex;
    overflow-y: auto;
    position: absolute;
    touch-action: none;
}
.v-easy-dialog--content-container:focus {
    outline: none;
}
.v-easy-dialog--persist {
    animation: shake 0.15s;
}

.textSend{
    background-color: #fff;
    border-radius: 10px;
}

.textSend div p{
    padding: 10px 10px 10px 10px;
    margin: 0px 0px 0px 0px;
    color: #000;
    font-size: 15px;
}

@media(min-width: 1024px)
{
    .motBusUser
    {
        width: 800px;
        margin: 10px auto;
    }
}

</style>